module.exports = __webpack_public_path__ + "static/media/MediumScoreBoy.d7f8c746.svg";